/**
 * Renesia countdown: ticks down to the visitor's own local midnight (or the
 * end of their week) and rolls over automatically. Nothing is persisted and
 * no deadline is faked - when the clock hits zero it simply starts the next
 * day's window.
 */
class RenesiaCountdown extends HTMLElement {
  connectedCallback() {
    this.hours = this.querySelector('[data-hours]');
    this.minutes = this.querySelector('[data-minutes]');
    this.seconds = this.querySelector('[data-seconds]');
    this.mode = this.dataset.reset === 'week' ? 'week' : 'midnight';
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  target() {
    const now = new Date();
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
    if (this.mode === 'week') {
      // days until the coming Sunday midnight; 0 means tonight
      const daysLeft = (7 - now.getDay()) % 7;
      end.setDate(end.getDate() + daysLeft);
    }
    return end;
  }

  tick() {
    const remaining = Math.max(0, this.target() - new Date());
    const total = Math.floor(remaining / 1000);
    const pad = (n) => String(n).padStart(2, '0');
    if (this.hours) this.hours.textContent = pad(Math.floor(total / 3600));
    if (this.minutes) this.minutes.textContent = pad(Math.floor((total % 3600) / 60));
    if (this.seconds) this.seconds.textContent = pad(total % 60);
  }
}

if (!customElements.get('renesia-countdown')) {
  customElements.define('renesia-countdown', RenesiaCountdown);
}
